export enum INoahPropertiesServerType {
	Undefined,
	Noah,
	NoahES,
}
